import {useAppDispatch, useAppSelector} from '../functions/hooks';
import {Error} from '../../components/common/Error';
import {ControlledLoading} from '../../components/common/Loading';
import {useEffect} from 'react';
import {onAppLoad} from '../store/authSlice';
import {useDispatch} from 'react-redux';
import {Grid} from '@mui/material';
import LogRocket from 'logrocket';

const ReduxAuth = ({header, children}) => {
    const dispatch = useDispatch();

    const authenticated = useAppSelector((x) => x.auth.authenticated);
    const hasError = useAppSelector((x) => x.auth.hasError);
    const errorMessage = useAppSelector((x) => x.auth.errorMessage);
    const errorAdditionalDetail = useAppSelector(
        (x) => x.auth.errorAdditionalDetail
    );

    const userLoading = useAppSelector((x) => x.auth.userLoading);
    const user = useAppSelector((x) => x.auth.user);

    useEffect(() => {
        dispatch(onAppLoad());
    }, []);

    useEffect(()=>{
        if(authenticated && user){
            try{
            LogRocket.identify(user.userID, {
                name: user.displayName
            })
        }
        catch{
            //Dont care, just dont blow up
        }
        }

    },[authenticated, user])

    if (authenticated && !hasError && !userLoading && user) {
        return (
            <Grid container direction="column" spacing={0}>
                <Grid item sx={{marginRight:"-8px", marginLeft:"-8px"}}>
                    {header}
                </Grid>
                <Grid item flexGrow={2} display="flex">
                    {children}
                </Grid>
            </Grid>
        );
    } else if (authenticated && !hasError && userLoading) {
        return (
            <>
                {header}
                <ControlledLoading loading={true}></ControlledLoading>
            </>
        );
    } else if (hasError) {
        return (
            <>
                {header}
                <Error
                    errorMessage={errorMessage}
                    errorAdditionalDetail={errorAdditionalDetail}
                />
            </>
        );
    } else {
        return <ControlledLoading loading={true}></ControlledLoading>;
    }
};

export default ReduxAuth;
